import styled from 'styled-components';

export const FiltersPaneStyled = styled.div`
  width: calc(100% - 10px);
  max-height: 100%;
  display: grid;
  grid-template-columns: auto auto 30px;
  overflow-y: auto;
  padding: 5px;
  grid-row-gap: 5px;

  > .FilterResetAll {
    margin: 10px 0px;
    grid-column-start: 1;
    grid-column-end: 4;
    display: flex;
    flex-flow: row;
    align-items: center;
    > span {
      flex: 1;
      font-size: 25px;
    }
  }
`;